<template>
  <div>
    <div class="horizontal-item p-3">
      <div class="d-md-flex justify-content-between">
        <div class="d-md-flex">
          <div class="position-relative mb-2 mb-md-0">
            <small-carousel
              :images="images"
              :show-indicators="false"
              height="185px"
            ></small-carousel>
          </div>
          <div class="position-relative">
            <div>
              <div class="d-flex">
                <div class="date-info">
                  <h1 class="m-0">{{ day }}</h1>
                  <h4 class="text-uppercase m-0">{{ month }}</h4>
                </div>
                <div class="item-info">
                  <h6 class="mb-0 text-uppercase text-primary">
                    {{ categoria }}
                  </h6>
                  <h3 class="mb-0">{{ titolo }}</h3>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <p class="mb-1 text-uppercase text-nowrap">
                <img
                  src="../../../../assets/images/svg/black/icone_durata.svg"
                  height="12px"
                />
                <small
                  ><b
                    >{{ durata }} {{ durata > 1 ? "giorni" : "giorno" }}</b
                  ></small
                >
              </p>
              <p class="overflowParagraph">{{ descrizione }}</p>
            </div>
          </div>
        </div>
        <div :class="`${isMobile ? 'text-center' : ''}`">
          <div class="position-relative">
            <h5>a partire da</h5>
            <h1 class="currency">{{ prezzo }} &euro;</h1>
          </div>
          <button
            id="scegliExperience"
            :class="`btn btn-primary px-5 ${isMobile ? 'w-100' : ''}`"
            @click="onOpenDetail"
          >
            scegli
          </button>
        </div>
      </div>
    </div>
    <ModalExperienceDetail
      :value="value"
      :services="services"
      ref="modalExperienceDetail"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CarouselOne from "../../common/CarouselOne";
import {
  formatMoney,
  middleDateFormatter,
  SERVER_DATE_FORMAT,
} from "../../../../utils/formatter";
import AlertIcon from "../../common/utils/AlertIcon";
import ModalExperienceDetail from "./modals/ModalExperienceDetail";
import SearchExperienceServicesAction from "../../../actions/SearchExperienceServicesAction";
import SmallCarousel from "../../common/SmallCarousel";
import { REPARTO_NAME } from "../../../../utils/config";
import AnalyticEvents from "../../../common/AnalyticEvents";
import MobileDetector from "../../../common/MobileDetector";

export default {
  name: "HorizontalItemExperience",
  components: { SmallCarousel, ModalExperienceDetail, AlertIcon, CarouselOne },
  mixins: [SearchExperienceServicesAction, AnalyticEvents, MobileDetector],
  props: {
    value: Object,
    search: Object,
  },
  computed: {
    departureDate() {
      const { daysSelected } = this.value;
      const mask = daysSelected.concat(daysSelected);
      let dow = this.$moment(this.search.partenza).day() - 1;
      let daysToAdd = 0;
      // cerca tra i giorni disponibili dell'experience
      // calcola il numero di giorni in avanti da aggiungere
      // per arrivare alla prima data utile disponibile di quell'experience
      for (let i = 0; i < 7; i++) {
        const j = dow + i;
        if (mask[j]) {
          daysToAdd = i;
          break;
        }
      }
      return this.$moment(this.search.partenza).add(daysToAdd, "days").toDate();
    },
    day() {
      return this.$moment(this.departureDate).format("DD");
    },
    month() {
      return this.$moment(this.departureDate).format("MMM");
    },
    disabled() {
      return this.search.aereoporto === null || this.search.partenza === null;
    },
    titolo() {
      return this.value.titolo;
    },
    categoria() {
      return this.value.codiceCategoria.name;
    },
    durata() {
      return this.value.days.length;
    },
    prezzo() {
      return formatMoney(this.value.prezzo);
    },
    descrizione() {
      return this.value.descrizione;
    },
    image() {
      return this.value.images && this.value.images.length > 0
        ? this.value.images[0]
        : [];
    },
    images() {
      return this.value.images;
    },
    bgImageStyle() {
      if (!this.images) return "";
      return `background-image: url(${this.images[0]})`;
    },
  },
  methods: {
    ...mapGetters([
      "getSearch",
      "getTypesAereoporti",
      "getExperiences",
      "getItinerario",
    ]),
    ...mapActions([
      "addSearch",
      "modifyExperience",
      "addReplaceServizio",
      "loadFlights",
      "loadFlexibleDates",
      "loadHotels",
      "loadServizi",
      "loadTrasferimenti",
      "addSearch",
    ]),
    onSelect(event) {
      this.$emit("select", event);
    },
    services() {
      return this.value.days.map((item, index) => {
        // estrae la lista servizi dai giorni dell'experience
        let results = item.list
          ? item.list.map((item2) => {
              return {
                codice: item2.codiceServizio,
                fornitore: item2.fornitore,
                days: this.value.daysSelected,
              };
            })
          : [];
        // aggiunge il codice tour solo se non è già presente
        /*
        if (item.isHotelRichiesto && item.isTourAbilitato && !results.find(item2 => item2.codice === item.codiceTour)) {
          results.push({codice: item.codiceTour, fornitore: REPARTO_NAME, days: this.value.daysSelected})
        }
        */
        return {
          day: index,
          services: results,
        };
      });
    },
    tours() {
      let list = [];
      const experience = this.value;
      const start = this.departureDate;
      experience.days.forEach((day, index) => {
        const current = this.$moment(start)
          .add("days", index)
          .format(SERVER_DATE_FORMAT);
        if (
          day.isTourAbilitato &&
          day.codiceTour &&
          !list.some((item) => item.productId === day.codiceTour)
        ) {
          list.push({
            productId: day.codiceTour,
            startDate: current,
            reparto: REPARTO_NAME,
          });
        }
      });
      return list;
    },
    onOpenDetail() {
      this.trackResultExperienceScegli();
      const servizi = this.services();
      const tours = this.tours();
      const search = { ...this.getSearch(), partenza: this.departureDate };
      const payload = {
        days: this.value.days.length,
        search,
        servizi,
        tours,
      };
      this.searchExperienceServices(payload)
        .then((response) => {
          const { servizi, tours } = response.object;
          this.$refs.modalExperienceDetail.open(
            this.departureDate,
            servizi,
            tours
          );
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    formatDate(date) {
      return middleDateFormatter(date);
    },
  },
  created() {},
};
</script>

<style scoped>
button {
  width: 150px;
}
.overflowParagraph {
  height: 85px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/experience/HorizontalItemExperience.vue